import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


import './files-gallery.css';

export default class FilesGallery extends React.Component {
	constructor(props) {
    super(props);
		this.state = {
			chatbox: props.channel,
			files: props.files,
		};
		this.clickuploadFile = this.clickuploadFile.bind(this);
	}

	async componentDidMount() {
	}

	componentWillUnmount() {
	}

	clickuploadFile(e) {
		//document.getElementById('upload').click();
		this.props.submit(e);
	}

	render() {
		const files = 
      Object.keys(this.state.files).map((e,i) => {
        return (
					<Col xs={6} onClick={()=>this.clickuploadFile(`${this.state.files[i].src}|${this.state.files[i].filename}|${this.state.files[i].type}|${this.state.files[i].size}`)}>
						<Row className="gx-0">
							<div className="files-gallery-type">
								<img src={`https://mix365.co.uk/images/filetypes/${this.state.files[i].type}.png`} alt="File type" />
							</div>
							<Col className="files-gallery-content">
								{this.state.files[i].filename}<br />
								Size: {this.state.files[i].size}
							</Col>
						</Row>
					</Col>
				)
			})
		return (
			<div className="files-gallery text-oppisite">
				<Row>
					{files}
				</Row>
			</div>
		)
	}
}